<template>
    <div>
        <el-row :gutter="15">
            <el-col :span="10">
                <el-card class="function-card" style="margin-top: 15px">
                    <el-row class="title_row">
                        <el-col :span="12">
                            <span class="title_class">裁判功能</span>
                        </el-col>
                    </el-row>
                    <div class="button-container">
                        <el-button
                            type="primary"
                            size="small"
                            plain
                            icon="el-icon-success"
                            @click="getLoginList(1)"
                            >登录情况</el-button
                        >
                        <!-- <el-button type="primary" plain icon="el-icon-s-data" v-if="isGroup === 2" @click="showStuList(2)">实时排名</el-button> -->
                        <!-- <el-button type="primary" plain icon="el-icon-document" v-if="isGroup === 1" @click="showStuList(2)">答题详情</el-button> -->
                        <el-button
                            type="primary"
                            size="small"
                            plain
                            icon="el-icon-link"
                            @click="copy('semiWelcome', 1)"
                            >大屏欢迎页</el-button
                        >
                        <el-button
                            type="primary"
                            size="small"
                            plain
                            icon="el-icon-link"
                            @click="copy('semiThirdRound', 1)"
                            >选手登录页</el-button
                        >
                        <!-- <el-button type="primary" plain icon="el-icon-s-platform" @click="copy('semiWelcome', 2)" v-if="examInfo && examInfo.matchTng !== 2">电视欢迎页</el-button> -->
                        <el-button
                            type="primary"
                            size="small"
                            plain
                            icon="el-icon-link"
                            @click="copy('semiRank')"
                            v-if="examInfo && examInfo.matchTng === 2"
                            >大屏排名</el-button
                        >
                        <el-button
                            type="primary"
                            size="small"
                            plain
                            icon="el-icon-s-tools"
                            @click="showStuList(3)"
                            v-if="
                                examInfo &&
                                examInfo.matchTng === 2 &&
                                queryForm.isGroup === 2
                            "
                            >设置晋级人数</el-button
                        >
                        <el-button
                            type="warning"
                            size="small"
                            :disabled="!examInfo && examInfo.matchTng !== 0"
                            @click="getExamQuestion()"
                            >获取考题</el-button
                        >
                    </div>
                </el-card>
            </el-col>
            <el-col :span="14">
                <el-card class="filter-card" style="margin-top: 15px">
                    <el-row class="title_row">
                        <el-col :span="12">
                            <span class="title_class">筛选</span>
                        </el-col>
                    </el-row>
                    <el-form
                        :model="queryForm"
                        class="filter_Form"
                        label-width="60px"
                        ref="queryFormRef"
                    >
                        <el-row :gutter="20">
                            <el-col :span="8">
                                <el-form-item
                                    label="赛季"
                                    prop="season"
                                    style="margin-bottom: 0"
                                >
                                    <el-select
                                        placeholder="请选择"
                                        style="width: 100%"
                                        v-model="queryForm.season"
                                        @change="seasonChange"
                                    >
                                        <el-option
                                            v-for="item in dict_season"
                                            :key="item.dictValue"
                                            :label="item.dictLabel"
                                            :value="item.dictValue"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="赛区" prop="districtId">
                                    <el-select
                                        placeholder="请选择"
                                        filterable
                                        style="width: 100%"
                                        v-model="queryForm.districtId"
                                        @change="changeFn"
                                    >
                                        <el-option
                                            v-for="item in dict_district"
                                            :key="item.id"
                                            :label="item.districtName"
                                            :value="item.id"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item
                                    label="考场"
                                    prop="examRoomId"
                                >
                                    <el-select
                                        placeholder="请选择"
                                        style="width: 100%"
                                        v-model="examRoomId"
                                        filterable
                                        @change="examRoomChange"
                                    >
                                        <el-option
                                            v-for="(item, index) in examRooms"
                                            :key="index"
                                            :label="item.roomName"
                                            :value="item.id"
                                        ></el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </el-form>
                </el-card>
            </el-col>
        </el-row>
        <el-card
            style="margin-top: 15px"
            v-if="examRoomId && groups.length > 0"
        >
            <el-row class="title_row">
                <el-col :span="12">
                    <span class="title_class">
                        <span style="margin-right: 12px">{{
                            examInfo && examInfo.formName
                                ? examInfo.formName
                                : ""
                        }}</span>
                        <el-tag
                            :type="
                                examInfo && examInfo.matchTng === 0
                                    ? 'warning'
                                    : examInfo && examInfo.matchTng === 1
                                    ? ''
                                    : 'danger'
                            "
                        >
                            {{
                                examInfo && examInfo.matchTng === 0
                                    ? "未开始"
                                    : examInfo && examInfo.matchTng === 1
                                    ? "进行中"
                                    : "已结束"
                            }}
                        </el-tag>
                        <i
                            class="refresh"
                            :class="
                                loading ? 'el-icon-loading' : 'el-icon-refresh'
                            "
                            @click="searchFn"
                        ></i>
                    </span>
                </el-col>
                <el-col :span="12" style="text-align: right">
                    <!-- matchTng 比赛开始 0未开始， 1 开始比赛 2 结束比赛 -->
                    <el-button
                        type="success"
                        :disabled="!examInfo || examInfo.matchTng !== 0"
                        @click="matchControlFn(1)"
                        >开始比赛</el-button
                    >
                    <el-button
                        type="danger"
                        :disabled="!examInfo || examInfo.matchTng !== 1"
                        @click="matchControlFn(2)"
                        >本场比赛结束</el-button
                    >
                </el-col>
            </el-row>
            <el-table
                header-cell-class-name="tableHeaderStyle"
                :data="dataList"
                border
                :row-class-name="rowClass"
            >
                <el-table-column label="序号" prop="quizSequence" width="60px">
                    <template slot-scope="scope">
                        {{ scope.row.quizSequence }}
                    </template>
                </el-table-column>
                <el-table-column label="题型" prop="typeName" width="130px">
                    <template slot-scope="scope">
                        {{ scope.row.typeName }}<br />{{
                            scope.row.typeEngName
                        }}
                    </template>
                </el-table-column>
                <el-table-column
                    label="Pinyin"
                    prop="pinYin"
                    width="90"
                    align="center"
                >
                    <template slot-scope="scope">
                        <span class="bid-font">{{ scope.row.pinYin }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="Meaning" prop="meaning">
                    <template slot-scope="scope">
                        <span class="bid-font">{{ scope.row.meaning }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="Sentence" prop="sentence" width="212">
                    <template slot-scope="scope">
                        <span class="bid-font">{{ scope.row.sentence }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="小题序号"
                    prop="quizNumber"
                    width="80px"
                >
                    <template slot-scope="scope">
                        <div style="display: flex; align-items: center">
                            {{ scope.row.quizNumber }}
                            <el-tag
                                v-if="scope.row.isStandby"
                                type="warning"
                                size="mini"
                                style="margin-left: 4px"
                                >备用</el-tag
                            >
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="Character" prop="word">
                    <template slot-scope="scope">
                        <span class="bid-font">{{ scope.row.word }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="古字形" prop="choicePic" width="130px">
                    <template slot-scope="scope">
                        <img style="width: 100px; height: 100px;" :src="scope.row.choicePic" />
                    </template>
                </el-table-column>
                                <el-table-column label="选项A" prop="choice" width="200">
                    <template slot-scope="scope">
                        <div class="grid-container">
                            <div
                                class="grid-item"
                                v-for="(font, index) of scope.row.choiceList"
                                :key="index"
                            >
                                {{ font }}
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="选项B" prop="choiceB" width="200">
                    <template slot-scope="scope">
                        <div class="grid-container">
                            <div
                                class="grid-item"
                                v-for="(font, index) of scope.row.choiceBList"
                                :key="index"
                            >
                                {{ font }}
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="答案" prop="answer" width="80px">
                    <template slot-scope="scope">
                        <div style="display: flex; align-items: center">
                            <div
                                v-for="(a, aIndex) of scope.row.answerList"
                                :key="aIndex"
                            >
                                <div class="choice-img" v-if="a.length > 5">
                                    <img :src="a" class="" />
                                </div>
                                <span v-else style="margin-right: 4px">{{
                                    a
                                }}</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="答题状态" prop="quizIng" width="140">
                    <template slot-scope="scope">
                        <el-tag
                            :type="
                                scope.row.quizIng === 0
                                    ? 'info'
                                    : scope.row.quizIng === 1
                                    ? ''
                                    : 'success'
                            "
                            size="mini"
                        >
                            {{
                                scope.row.quizIng === 0
                                    ? "未作答"
                                    : scope.row.quizIng === 1
                                    ? "作答中"
                                    : "作答完成"
                            }}
                        </el-tag>
                        <span class="timer" v-if="scope.row.quizIng === 1">{{
                            timeStr
                        }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="是否作废" prop="quizIng" width="90">
                    <template slot-scope="scope">
                        <el-tag
                            :type="
                                scope.row.isDiscard === 0 ? 'success' : 'danger'
                            "
                            size="mini"
                        >
                            {{ scope.row.isDiscard === 0 ? "正常" : "作废" }}
                        </el-tag>
                    </template>
                </el-table-column>

                <el-table-column label="操作" width="378" fixed="right">
                    <template slot-scope="scope">
                        <el-button
                            type="success"
                            size="small"
                            :disabled="
                                !examInfo ||
                                examInfo.matchTng !== 1 ||
                                scope.row.quizIng !== 0
                            "
                            @click="quesControlFn(scope.row, 1)"
                            >开始作答</el-button
                        >
                        <!-- <el-button type=info" size="small" class="mr-20" :disabled="examInfo.matchTng !== 1 || scope.row.quizIng !== 1" @click="quesControlDone(scope.row, 'countDown', 0)">重新计时</el-button> -->
                        <el-button
                            type="warning"
                            size="small"
                            :disabled="
                                !examInfo ||
                                examInfo.matchTng !== 1 ||
                                scope.row.quizIng !== 1
                            "
                            @click="quesControlDone(scope.row, 'countDown', 1)"
                            v-if="scope.row.countDown !== 1"
                            >暂停计时</el-button
                        >
                        <el-button
                            type="primary"
                            size="small"
                            :disabled="
                                !examInfo ||
                                examInfo.matchTng !== 1 ||
                                scope.row.quizIng !== 1
                            "
                            @click="quesControlDone(scope.row, 'countDown', 2)"
                            v-if="scope.row.countDown === 1"
                            >继续作答</el-button
                        >
                        <el-button
                            type="danger"
                            size="small"
                            @click="quesControlFn(scope.row, 3)"
                            >本题作废</el-button
                        >
                        <el-button
                            type="primary"
                            size="small"
                            :disabled="
                                !examInfo ||
                                examInfo.matchTng !== 1 ||
                                scope.row.quizIng !== 1 ||
                                scope.row.countDown === 1
                            "
                            @click="quesControlFn(scope.row, 2)"
                            >结束作答</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>

            <el-button
                type="danger"
                style="display: block; margin: 40px auto 20px"
                :disabled="!examInfo || examInfo.matchTng !== 1"
                @click="matchControlFn(2)"
                >本场比赛结束</el-button
            >
        </el-card>
        <!-- 登录情况 -->
        <el-dialog :visible.sync="dialogVisible" width="80%">
            <span slot="title">
                {{ dialogTitle }}
                <i
                    class="refresh"
                    :class="loading ? 'el-icon-loading' : 'el-icon-refresh'"
                    @click="getLoginList(1)"
                ></i>
                <el-button
                    type="primary"
                    v-if="dialogType === 1"
                    style="margin-left: 24px"
                    plain
                    icon="el-icon-link"
                    @click="copy('pad')"
                    >PAD端欢迎链接</el-button
                >
            </span>
            <div class="set-info" v-if="dialogType === 3">
                <span>设置晋级到B轮人数：</span>
                <el-input-number
                    v-model="topNum"
                    :min="1"
                    :max="stuList.length"
                ></el-input-number>
                <el-button
                    type="primary"
                    style="margin-left: 20px"
                    @click="setNextNumFn"
                    >确认</el-button
                >
            </div>
            <!-- 实时排名 -->
            <el-tabs
                type="border-card"
                @tab-click="handleClick"
                v-model="queryStuForm.drawOnePromote"
                v-if="dialogType === 2 && isGroup === 2"
            >
                <el-tab-pane label="晋级名单" name="1"></el-tab-pane>
                <el-tab-pane label="淘汰名单" name="0"></el-tab-pane>
                <el-tab-pane label="未设置" name="-1"></el-tab-pane>
            </el-tabs>
            <el-table
                style="margin-top: 0"
                v-if="dialogVisible"
                header-cell-class-name="tableHeaderStyle"
                :data="stuList"
                :row-class-name="tableRowClassName"
                border
            >
                <el-table-column label="序号" type="index"></el-table-column>
                <!-- <el-table-column label="赛季" prop="season"></el-table-column> -->
                <el-table-column label="姓名" prop="userName">
                    <template slot-scope="scope">
                        <span class="num num1">{{ scope.row.userName }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="比赛号码牌" prop="number">
                    <template slot-scope="scope">
                        <span class="num num1">{{
                            addZero(scope.row.number)
                        }}</span>
                    </template>
                </el-table-column>
                <el-table-column
                    label="排名"
                    prop="drawOneRank"
                    v-if="dialogType === 2 && isGroup === 2"
                >
                    <template slot-scope="scope">
                        <div class="rank-index">
                            {{ scope.row.drawOneRank }}
                        </div>
                    </template>
                </el-table-column>
                <el-table-column
                    label="分数"
                    prop="roundOne"
                    v-if="dialogType === 2 || dialogType === 3"
                ></el-table-column>
                <el-table-column
                    label="晋级状态"
                    prop="drawOnePromote"
                    v-if="dialogType === 2 && isGroup === 2"
                >
                    <template slot-scope="scope">
                        <el-select
                            v-model="scope.row.drawOnePromote"
                            @change="promoteChange(scope.row)"
                            size="small"
                            :class="'promote' + scope.row.drawOnePromote"
                        >
                            <el-option
                                v-for="item in pList"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column
                    label="学校"
                    prop="schoolName"
                ></el-table-column>
                <el-table-column label="手机号" prop="phone"></el-table-column>
                <!-- <el-table-column
          label="组别"
          prop="enrollmentLevel"
          :formatter="levelFormatter"
        ></el-table-column> -->
                <el-table-column
                    label="年级"
                    prop="grade"
                    :formatter="gradeFormatter"
                ></el-table-column>
                <el-table-column
                    label="登录状态"
                    prop="loginState"
                    v-if="dialogType === 1"
                >
                    <template slot-scope="scope">
                        <el-button
                            plain
                            :type="scope.row.loginState ? 'success' : 'danger'"
                            size="small"
                            :icon="
                                scope.row.loginState
                                    ? 'el-icon-success'
                                    : 'el-icon-warning'
                            "
                        >
                            {{ scope.row.loginState ? "已登录" : "未登录" }}
                        </el-button>
                    </template>
                </el-table-column>
                <el-table-column
                    label="操作"
                    fixed="right"
                    v-if="dialogType === 2"
                >
                    <template slot-scope="scope">
                        <el-button
                            type="text"
                            size="small"
                            @click="showDetail(scope.row)"
                            >答题详情</el-button
                        >
                    </template>
                </el-table-column>
            </el-table>
        </el-dialog>

        <!-- 答题详情 -->
        <el-dialog title="作答详情" :visible.sync="detailVisible" width="900px">
            <el-row>
                <el-col :span="6"
                    ><div class="total">
                        姓名：<span>{{ userName }}</span>
                    </div></el-col
                >
                <el-col :span="6"
                    ><div class="total">
                        比赛号码牌：<span
                            style="
                                color: #000;
                                font-weight: bold;
                                font-size: 20px;
                            "
                            >{{ matchNum }}</span
                        >
                    </div></el-col
                >
                <el-col :span="6"
                    ><div class="total">
                        总分：<span>{{ totalScore }}</span>
                    </div></el-col
                >
            </el-row>
            <el-table
                header-cell-class-name="tableHeaderStyle"
                :data="paperData"
                stripe
                border
            >
                <el-table-column prop="quizNumber" label="题号" width="80px">
                    <template slot-scope="scope">
                        {{ scope.row.quizNumber }}
                        <span v-if="scope.row.isStandby === 1">(备用)</span>
                    </template>
                </el-table-column>
                <el-table-column prop="typeName" label="题型"></el-table-column>
                <el-table-column label="正确答案" prop="correctAnswerList">
                    <template slot-scope="scope">
                        <div class="font-flex">
                            <div
                                class="font-box"
                                v-for="(font, fi) of scope.row
                                    .correctAnswerList"
                                :key="font"
                            >
                                <img
                                    class="answer-img"
                                    v-if="font.length > 5"
                                    :key="fi"
                                    :src="font"
                                    alt=""
                                />
                                <span class="font" v-else>{{ font }}</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="用户答案" prop="answerList">
                    <template slot-scope="scope">
                        <div
                            class="font-flex"
                            v-if="scope.row.answerList.length"
                        >
                            <div
                                class="font-box"
                                v-for="(font, fi) of scope.row.answerList"
                                :key="font"
                            >
                                <img
                                    class="answer-img"
                                    v-if="font.length > 5"
                                    :key="fi"
                                    :src="font"
                                    alt=""
                                />
                                <span class="font" v-else>{{ font }}</span>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="score" label="得分">
                    <template slot-scope="scope">
                        <el-input
                            v-model="scope.row.score"
                            type="number"
                            @blur="saveScore(scope.row)"
                            style="width: 120px"
                        ></el-input>
                    </template>
                </el-table-column>
                <el-table-column label="判定">
                    <template slot-scope="scope">
                        <el-tag
                            v-if="scope.row.score !== undefined"
                            :type="
                                scope.row.score === 0 || scope.row.score === '0'
                                    ? 'danger'
                                    : 'success'
                            "
                            size="mini"
                        >
                            {{
                                scope.row.score === 0 || scope.row.score === "0"
                                    ? "错误"
                                    : "正确"
                            }}
                        </el-tag>
                    </template>
                </el-table-column>
            </el-table>
            <!-- </div> -->
        </el-dialog>
    </div>
</template>
<script>
import { queryDistrictPage } from '@/http/api'
import Vue from 'vue'
export default {
  name: 'groupA',
  props: {
    flag: { // 1-A有组别  2-A无组别
      Type: String,
      default: 0
    }
  },
  data () {
    return {
      dict_season: [],
      groups: [],
      queryForm: {
        activityType: this.$chnEngStatusCode.activityType,
        season: this.$chnEngStatusCode.defaultSeason,
        isGroup: 1,
        nationalFormId: '',
        raceSchedule: this.$chnEngStatusCode.raceScheduleRegional,
        phase: 3
      },
      dialogTitle: '',
      dialogType: 0,
      detailVisible: false,
      dialogVisible: false,
      stuList: [],
      dict_grade: this.$userInfo.getGradeData() || [],
      dict_group: this.$userInfo.dict_group() || [],
      queryStuForm: {
        activityType: this.$chnEngStatusCode.activityType,
        season: this.$chnEngStatusCode.defaultSeason,
        raceSchedule: this.$chnEngStatusCode.raceScheduleRegional,
        isGroup: 1
        // drawOnePromote: '1' // 1:晋级 0:未晋级 -1:未设置
      },
      isGroup: 1,
      totalScore: 0,
      userName: '',
      matchNum: '',
      examRoomId: '',
      paperData: {},
      examInfo: {
        matchTng: 0,
        label: ''
      },
      examRooms: [],
      show2Min: false, // 是否显示2分钟倒计时
      lastQuiz: false, // 是否是最后一题
      level: '', // 组别
      examRoomInfo: {},
      dict_matchType: [],
      dataList: [],
      dict_district: [], // 赛区下拉列表
      loading: false,
      topNum: '',
      clickMatchTng: '',
      timeStr: '00:00',
      pList: [
        { label: '晋级', value: 1 },
        { label: '淘汰', value: 0 },
        { label: '未设置', value: -1 }
      ]
    }
  },
  created () {
    // 确保字典数据被正确初始化
    if (!this.dict_grade || !this.dict_grade.length) {
      this.dict_grade = this.$userInfo.getGradeData() || []
    }
    if (!this.dict_group || !this.dict_group.length) {
      this.dict_group = this.$userInfo.dict_group() || []
    }
    // 初始化数据
    this.init()
  },
  methods: {
    init3D () {
      this.show2Min = false
      this.lastQuiz = false
      this.level = ''
      const params = this.$route.query
      console.log('params', params)
      if (params.id) {
        this.queryForm.season = params.s
        this.queryForm.districtId = params.d
        this.examRoomId = params.id
      }
      // 赛程--默认传入复赛 2 写死的
      this.$chnEngPublicRequest.querySeasonRaceSchedule(this, {}).then(value => {
        this.dict_matchType = value
      })
      // 赛区--不传入默认取全国非
      this.getDistrictList(params.d)
    },
    init () {
      this.$userInfo.getDataList(this, 't_season').then(value => {
        this.dict_season = value
        // this.queryForm.season = value[0].dictValue
        // this.getGroups(0)
      })
    },
    rowClass ({ row, rowIndex }) {
      return row.isStandby ? 'isStandby' : ''
    },
    tableRowClassName ({ row, rowIndex }) {
      if (rowIndex < this.topNum) {
        return 'success-row'
      }
      return ''
    },
    seasonChange () {
      this.getGroups(0)
    },
    getGroups (type) {
      console.log('getGroups', this.examRoomId)
      const { season, activityType, isGroup } = this.queryForm
      this.$http.get('national/queryNationalGroupFormLevel', { params: { season, activityType, isGroup, examinationRoomId: this.examRoomId, phase: this.queryForm.phase, raceSchedule: '2' } }).then(res => {
        console.log('queryNationalGroupFormLevel', res)
        this.groups = res.data
        if (res.code === 200) {
          if (!this.groups.length) {
            this.dataList = []
            this.$message.warning('暂无考题信息！') // 成功提示信息
            return
          }
          this.groups.forEach(item => {
            const found = this.dict_group.find(g => g.dictValue === item.formLevel)
            item.label = found ? found.dictLabel : '--'
          })
          console.log('groups', this.groups)
          this.examInfo = this.groups[0]
          this.queryForm.nationalFormId = this.examInfo.id
          this.getPaper()
        }
      })
    },
    // 获取赛区筛选数据
    getDistrictList (districtId) {
      queryDistrictPage({ pageNum: 1, pageSize: 10000 }).then((res) => {
        this.dict_district = res.data.list || []
        // if (this.dict_district.length > 1) {
        //   this.queryForm.districtId = districtId || this.dict_district[1].id
        // }
        this.getExamRoomSelect()
      }).catch((err) => {
        console.log('err', err)
        this.dict_district = []
        this.getExamRoomSelect()
      })
    },
    // 获取考场列表
    getExamRoomSelect () {
      this.$http.get('examination/queryExaminationList', { params: this.queryForm }).then(res => {
        this.examRooms = res.data || []
        if (this.examRoomId) { // 路径带入，直接获取信息
          this.examRoomInfo = this.examRooms.find(item => item.id === this.examRoomId)
          this.loading = true
          this.getGroups(1)
        }
      }).catch((err) => {
        console.log('err', err)
        this.examRooms = []
      })
    },
    // 切换考场
    examRoomChange (e) {
      // 修改考场信息
      this.examRoomInfo = this.examRooms.find(item => item.id === this.examRoomId) || null
      this.loading = true
      this.getGroups(1)
    },
    getList () {
      this.isLoading = true
      this.$http.get('/examinationUser/getQuestionById', { params: { id: this.examRoomId } }).then(res => {
        if (res.code === 200) {
          this.getStatus()
          this.dataList = res.data || []
          this.dataList.forEach(item => {
            // 选项
            if (item.choice && item.choice.includes('http')) {
              item.choiceType = 1
            } else {
              item.choiceType = 2
            }
            item.choiceList = item.choice ? item.choice.split(',') : []
            item.choiceBList = item.choiceB ? item.choiceB.split(',') : []
            // 答案
            item.answerList = item.answer
          })
          this.currentIndex = this.dataList.findIndex(item => item.usedIng)
        }
        this.isLoading = false
      }).catch((err) => {
        console.log('err', err)
        this.dataList = []
        this.isLoading = false
      })
    },
    getStatus () {
      this.$http.get('examinationUser/getProgress?id=' + this.examRoomId).then(res => {
        if (res.code === 200) {
          this.matchEndType = res.data ? res.data.matchEndType : 0
        }
      })
    },
    changeFn () {
      this.examRoomId = ''
      this.getExamRoomSelect()
    },
    searchFn () {
      this.loading = true
      this.getGroups(1)
    },
    getPaper () {
      console.log('getPaper', this.examRoomId)
      this.$http.get('national/queryNationalGroupForm', { params: { ...this.queryForm, examinationRoomId: this.examRoomId, phase: this.queryForm.phase } }).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.dataList = res.data || []
          if (!this.dataList.length) return
          this.dataList.forEach(item => {
            // 选项
            if (item.choice && item.choice.includes('http')) {
              item.choiceType = 1
            } else {
              item.choiceType = 2
            }
            item.choiceList = item.choice ? item.choice.split(',') : []
            item.choiceBList = item.choiceB ? item.choiceB.split(',') : []
            // 答案
            item.answerList = item.answer
          })
        }
      }).catch((err) => {
        console.log('err', err)
        this.loading = false
        this.dataList = []
      })
    },
    startCountdown (quizTime) {
      this.timer = setInterval(() => {
        quizTime--
        console.log(quizTime)
        if (quizTime > 0) {
          this.timeStr = this.$xcUtils.sec2time(quizTime)
        } else {
          this.timeStr = '00:00'
          this.stopCountdown()
        }
      }, 1000)
    },
    stopCountdown () {
      clearInterval(this.timer)
      this.timer = null
    },
    // 全场开始/结束
    matchControlFn (matchTng) {
      this.clickMatchTng = matchTng
      if (matchTng === 2) {
        this.$confirm('确认结束本场比赛？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.matchControlDone(matchTng)
        }).catch(() => {
        })
      } else if (matchTng === 1) {
        this.matchControlDone(matchTng)
      }
    },
    getExamQuestion () {
      this.$http.post('examination/copyRoundTwoGroupForm', {
        id: this.examRoomId,
        phase: this.queryForm.phase
      }).then(res => {
        if (res.code === 200) {
          this.examRoomChange()
          this.$message.success('考题已生成')
        }
      })
    },
    matchControlDone (matchTng) {
      this.$http.post('national/updateNationalGroupFormLevel', {
        id: this.examInfo.id,
        matchTng
      }).then(res => {
        if (res.code === 200) {
          // 无组别A轮结束比赛设置晋级人数
          if (this.clickMatchTng === 2 && this.queryForm.isGroup === 2) {
            this.showStuList(3)
          } else {
            this.$message.success(`比赛${matchTng === 1 ? '开始' : '结束'}`)
            this.examInfo.matchTng = matchTng
          }
        }
      })
    },
    // 作答点击
    quesControlFn (item, quizIng) {
      if (quizIng === 2) {
        const ask = `题目${item.quizNumber}：确认结束本题？`
        this.$confirm(ask, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.quesControlDone(item, 'quizIng', quizIng)
        }).catch(() => {
        })
      } else if (quizIng === 3) {
        const ask = `题目${item.quizNumber}：确认作废本题？作废后本题目将不计入最终成绩`
        this.$confirm(ask, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.quesControlDone(item, 'isDiscard', 1)
          // setTimeout(() => {
          //   this.quesControlDone(item, 'quizIng', 2)
          // }, 1000)
        }).catch(() => {
        })
      } else if (quizIng === 1) {
        this.quesControlDone(item, 'quizIng', quizIng)
      }
    },
    /**
             * 操作
             * @param {*} item 行数据
             * @param {*} key quizIng/countDown
             * @param {*} value
             */
    quesControlDone (item, key, value) {
      if (key === 'countDown') {
        if (value === 1) { // 暂停
          this.stopCountdown()
        } else if (value === 2) { // 继续
          const t = this.timeStr.split(':')
          const sec = parseInt(t[0]) * 60 + parseInt(t[1])
          this.startCountdown(sec)
        }
      }
      const data = {}
      data.id = item.id
      data[key] = value
      this.$http.post('national/updateNationalGroupFormInfo', data).then(res => {
        if (res.code === 200) {
          if (key === 'quizIng' && value === 1) {
            console.log('开始作答~~~~~~~~~~')
            Vue.$showLoading.show()
            setTimeout(() => {
              this.startCountdown(60)
            }, 3000)
          } else if (key === 'isDiscard' && value === 1) {
            this.stopCountdown()
            this.timeStr = '00:00'
          } else if (key === 'quizIng' && value === 2) {
            this.stopCountdown()
            this.timeStr = '00:00'
            this.loadingData = this.$loading({
              lock: true,
              text: '加载中',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            })
            setTimeout(() => {
              this.loadingData.close()
              this.$message.success('本题作答结束')
            }, 3000)
          }
          this.getPaper()
        }
      })
    },
    gradeFormatter (data) {
      if (!data.grade || !this.dict_grade) return '--'
      const found = this.dict_grade.find(item => item.dictValue === data.grade)
      return found ? found.dictLabel : '--'
    },
    levelFormatter (data) {
      if (!data.level || !this.dict_group) return '--'
      const found = this.dict_group.find(item => item.dictCode === data.level)
      return found ? found.dictLabel : '--'
    },
    addZero (num) {
      return this.$xcUtils.addZero(num)
    },
    showStuList (type, init = true) { // 1-登录情况 2-实时排名 3-设置晋级人数
      this.loading = true
      this.dialogTitle = type === 1 ? '登录情况' : type === 2 ? '实时排名' : '设置晋级人数'
      this.dialogType = type
      this.queryStuForm.activityType = this.queryForm.activityType
      this.queryStuForm.season = this.queryForm.season
      if (this.isGroup === 2 && init) {
        this.queryStuForm.drawOnePromote = '1'
      }
      this.getStuList(type)
    },
    getLoginList (type, init = true) {
      if (!this.examRoomId || this.examRoomId === '') {
        this.$message.warning('请先选择考场')
        return
      }
      this.loading = true
      this.dialogTitle = type === 1 ? '登录情况' : type === 2 ? '实时排名' : '设置晋级人数'
      this.dialogType = type
      this.loading = true
      this.$http.get('/examinationUser/selectEnrollmentRoundInfoIsLoginList', { params: { ...this.queryStuForm, ...{ id: this.examRoomId, phase: this.queryForm.phase } } }).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.stuList = res.data || []
          this.dialogVisible = true
          console.log(this.stuList)
        }
      }).catch((err) => {
        console.log('err', err)
        this.loading = false
        this.stuList = []
      })
    },
    getStuList (type) {
      this.$http.get('/national/queryNationalGroupList', { params: { ...this.queryStuForm, ...{ level: this.quizLevel, phase: this.queryForm.phase } } }).then(res => {
        this.loading = false
        if (res.code === 200) {
          this.stuList = res.data || []
          this.dialogVisible = true
          console.log(this.stuList)
          if (type === 3) {
            // this.topNum = this.stuList.length
            this.topNum = 10
          }
        }
      }).catch((err) => {
        console.log('err', err)
        this.loading = false
        this.stuList = []
      })
    },
    handleClick (e) {
      this.queryStuForm.drawOnePromote = e.name
      this.showStuList(2, false)
    },
    promoteChange (item) {
      console.log(item)
      this.$http.post('national/updateDrawOnePromote', {
        drawOnePromote: item.drawOnePromote,
        nationalId: item.nationalId
      }).then(res => {
        if (res.code === 200) {
          this.$message.success('修改成功')
          this.getStuList(2)
        }
      })
    },
    showDetail (data) {
      this.userName = data.userName
      this.phone = data.phone
      this.matchNum = this.addZero(data.matchNum)
      this.userId = data.userId

      const params = {
        activityType: this.queryForm.activityType,
        season: this.queryForm.season,
        isGroup: this.queryForm.isGroup,
        nationalId: data.nationalId,
        userId: data.userId,
        level: this.queryForm.isGroup === 1 ? data.level : ''
      }
      this.$http.get('/national/queryNationalAnswerInfo', { params }).then(res => {
        if (res.code === 200) {
          if (res.data.answerInfos && res.data.answerInfos.length) {
            this.detailVisible = true
            this.totalScore = res.data.roundOne
            this.nationalGroupId = res.data.nationalGroupId
            this.nationalId = res.data.nationalId
            res.data.answerInfos.forEach(item => {
              item.answerList = item.answer ? item.answer.split(',') : []
              item.correctAnswerList = item.correctAnswer ? item.correctAnswer.split(',') : []
            })
            this.paperData = res.data.answerInfos
          } else {
            this.$message.warning('暂无答题记录')
          }
        }
      })
    },
    // type 0-默认无意义 1-大屏 2-电视
    // str 'welcome' 'rank' 'pad'
    // 投屏：大屏/电视分不同比例分开处理
    copy (str, type = 0) {
      if (!this.queryForm.season) {
        return this.$message.warning('请选择赛季')
      }
      if (!this.examRoomId || this.examRoomId === '') {
        this.$message.warning('请先选择考场')
        return
      }
      var input = document.createElement('input') // 创建input标签
      var loc = window.location.origin
      const query = {
        activityType: this.queryForm.activityType,
        season: this.queryForm.season,
        group: this.queryForm.isGroup,
        raceSchedule: this.queryForm.raceSchedule,
        phase: this.queryForm.phase,
        examinationRoomId: this.examRoomId,
        isShowScore: 1,
        districtId: this.queryForm.districtId
      }
      // if (this.queryForm.isGroup === 1) {
      //   query.level = this.quizLevel
      // }

      if (type === 2) {
        query.TV = 'TV'
      }

      if (str === 'pad') { // pad端链接
        input.value = `${loc}/#/pad/pw?season=${this.queryForm.season}` // 将input的值设置为需要复制的内容
      } else { // 大屏/电视
        input.value = `${loc}/#/${str}?${this.$xcUtils.serialize(query)}` // 将input的值设置为需要复制的内容
      }
      document.body.appendChild(input) // 添加input标签
      input.select() // 选中input标签
      document.execCommand('copy') // 执行复制
      this.$message.success('复制成功') // 成功提示信息
      document.body.removeChild(input) // 移除input标签
    },
    setNextNumFn () {
      console.log(this.examInfo)
      this.$http.post('/national/endNationalGroupRankOne', {
        activityType: this.queryForm.activityType,
        season: this.queryForm.season,
        isGroup: this.queryForm.isGroup,
        topNum: this.topNum,
        nationalFormId: this.examInfo.id
      }).then(res => {
        if (res.code === 200) {
          this.$message.success('设置成功')
          this.dialogVisible = false
          this.searchFn()
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.search {
    font-size: 14px;
}
.choice-img {
    width: 24px;
    height: 24px;
    padding-top: 1px;
    margin-right: 4px;
    border: 1px solid #409eff;
    border-radius: 4px;
    text-align: center;
    display: inline-block;
    img {
        height: 20px;
        width: auto;
    }
}
.choice-text {
    display: inline-block;
    width: 20px;
    height: 20px;
    text-align: center;
    line-height: 20px;
    margin: 2px;
    border: 1px solid #409eff;
    border-radius: 4px;
    font-size: 14px;
    color: #000;
}

.grid-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-template-rows: repeat(3, 1fr);
    gap: 2px;
    width: 120px;
    height: 120px;
}

.grid-item {
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid #409eff;
    border-radius: 4px;
    background-color: #f5f7fa;
    font-size: 12px;
    color: #000;
    min-width: 0;
    min-height: 0;
}
.mr-20 {
    margin-right: 10px;
}
.num {
    font-size: 18px;
    font-weight: bold;
    color: #409eff;
}
.num1 {
    color: #000;
}
.refresh {
    color: #409eff;
    cursor: pointer;
    margin-left: 12px;
}
/deep/ .el-table .cell {
    word-break: break-word;
    overflow-wrap: break-word;
}
.set-info {
    margin-bottom: 24px;
}
.bid-font {
    font-size: 14px;
    color: #000;
    word-break: keep-all;
}
.rank-index {
    color: red;
    font-size: 18px;
    font-weight: bold;
}
/deep/ .el-tabs {
    margin-bottom: 20px;
}
/deep/ .el-tabs__content {
    padding: 0;
}

.h1 {
    color: #000;
    margin-top: 20px;
}
.h2 {
    color: #000;
}
.total {
    font-size: 16px;
    color: #000;
    span {
        color: #409eff;
    }
}
.font-flex {
    display: flex;
    align-items: center;
}
.font-box {
    border: 1px solid #409eff;
    border-radius: 4px;
    width: 30px;
    height: 30px;
    text-align: center;
    line-height: 30px;
    margin: 4px;
}
.font {
    color: #000;
    font-size: 16px;
}

.answer-img {
    height: 26px;
    border-radius: 6px;
    margin-top: 1px;
}
.tab-search-card {
    background-color: #fff;
    padding: 20px;
}
// /deep/ .el-tabs--border-card{
//   border: none;
//   box-shadow: none;
// }
// /deep/ .el-tabs__content{
//   padding: 0;
// }
/deep/ .promote1 .el-input__inner {
    background: #67c23a;
    color: #fff;
}
/deep/ .promote0 .el-input__inner {
    background: #f56c6c;
    color: #fff;
}

// 卡片高度一致性样式
.function-card,
.filter-card {
    min-height: 140px;
    display: flex;
    flex-direction: column;
}

.function-card .el-card__body,
.filter-card .el-card__body {
    flex: 1;
    display: flex;
    flex-direction: column;
}

.button-container {
    flex: 1;
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    align-items: flex-start;
    padding-top: 10px;
}

.filter_Form {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.title_row {
    margin-bottom: 15px;
}
.timer {
    font-size: 16px;
    font-weight: bold;
    margin-left: 12px;
    color: #67c23a;
}
.title_class {
    font-size: 16px;
    // font-weight: bold;
    color: #303133;
}
</style>
